export default __webpack_public_path__ + "static/media/background.5ac06d46.png";